import tw, { styled } from "twin.macro";

const ToggleButton = styled.button<{ active: boolean }>([
  tw`flex items-center px-4 py-2 border rounded-lg text-black-alpha hover:border-black-gamma`,
  ({ active }) => (active ? tw`border-black-gamma` : tw`border-black-delta`),
]);

export default ToggleButton;
